import logoPNG from '../assets/brand/logo-png.png';
import '../css/main.css';
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'Projects', to: '/projects' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact Us', to: '/contacts' },
];

function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-sm shadow-md py-2'
          : 'bg-white py-3'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">

        {/* Logo */}
        <NavLink to="/" onClick={() => setMobileOpen(false)}>
          <img src={logoPNG} alt="Edges Design Group" className="h-10 w-auto" />
        </NavLink>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map(({ label, to }) => (
            to === '/contacts' ? (
              <NavLink
                key={label}
                to={to}
                className={({ isActive }) =>
                  `ml-4 px-5 py-2 rounded-full text-sm font-semibold transition-all duration-150 ${
                    isActive
                      ? 'bg-teal-700 text-white'
                      : 'bg-teal-600 text-white hover:bg-teal-700'
                  }`
                }
              >
                {label}
              </NavLink>
            ) : (
              <NavLink
                key={label}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  `px-3 py-1.5 text-sm font-medium rounded transition-all duration-150 ${
                    isActive
                      ? 'text-teal-600 font-semibold'
                      : 'text-gray-700 hover:text-teal-600'
                  }`
                }
              >
                {label}
              </NavLink>
            )
          ))}
        </nav>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 rounded-md text-gray-700 hover:text-teal-600 hover:bg-gray-100 transition"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-1">
          {navLinks.map(({ label, to }) => (
            to === '/contacts' ? (
              <NavLink
                key={label}
                to={to}
                className={({ isActive }) =>
                  `mt-2 px-5 py-2.5 rounded-full text-sm font-semibold text-center transition-all duration-150 ${
                    isActive
                      ? 'bg-teal-700 text-white'
                      : 'bg-teal-600 text-white hover:bg-teal-700'
                  }`
                }
                onClick={() => setMobileOpen(false)}
              >
                {label}
              </NavLink>
            ) : (
              <NavLink
                key={label}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium transition-all duration-150 ${
                    isActive
                      ? 'text-teal-600 bg-teal-50 font-semibold'
                      : 'text-gray-700 hover:text-teal-600 hover:bg-gray-50'
                  }`
                }
                onClick={() => setMobileOpen(false)}
              >
                {label}
              </NavLink>
            )
          ))}
        </div>
      </div>
    </header>
  );
}

export default NavBar;
